import { useEffect, useState } from "react";

const DEFAULT_CITY = "Barcelona";
const DEFAULT_LAT = 41.390205;
const DEFAULT_LNG = 2.154007;

export const useLocation = () => {
  //using useRef to store the location and not re-render the component
  const [latitude, setLatitude] = useState<number>(DEFAULT_LAT);
  const [longitude, setLongitude] = useState<number>(DEFAULT_LNG);
  const [city, setCity] = useState<string>(DEFAULT_CITY);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error);
    }
  }, []);

  useEffect(() => {
    if (latitude != 0 && longitude != 0) {
      setIsLoading(false);
    }
  }, [latitude, longitude]);

  function success(position: {
    coords: { latitude: number; longitude: number };
  }): void {
    setLatitude(position.coords.latitude);
    setLongitude(position.coords.longitude);
    //fetch the address using the google geocode api
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=${process.env.NEXT_PUBLIC_GEOCODING_KEY}`,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.results.length > 0) {
          setCity(data.results[0].address_components[3].long_name);
        }
      });
  }

  function error() {
    console.log("Unable to retrieve your location");
  }
  return { latitude, longitude, city, isLoading };
};
